import { useQuery } from '@tanstack/react-query';

export function useAsyncTreeNodeTotals<Ctx, Item, Ui>({
  queryKeyPrefix,
  ctx,
  item,
  enqueue,
  enabled,
  extraQueryKeyParts,
}: {
  queryKeyPrefix: string;
  ctx: Ctx | null;
  item: Item;
  enqueue: (ctx: Ctx, item: Item) => Promise<Ui>;
  enabled: boolean;
  extraQueryKeyParts: readonly unknown[];
}) {
  return useQuery({
    queryKey: [queryKeyPrefix, ...extraQueryKeyParts],
    queryFn: () => {
      if (!ctx) {
        throw new Error(`${queryKeyPrefix} query is not ready`);
      }
      return enqueue(ctx, item);
    },
    enabled: Boolean(enabled && ctx),
    staleTime: Infinity,
  });
}
